
$(document).ready(function() {

    // KLick auf Detaillierte Karte
    $('.ttgTourdataDetailseite, .ttgNewsDetail').on('click', '#ttgDetailKarteBtn', function() {
        $('button.mapboxgl-ctrl-fullscreen').trigger('click');
    });

});